import { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import "./style.css";

import Layout from "../../components/Layout";

import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Spinner from "react-bootstrap/Spinner";
import { InputMask } from "@react-input/mask";

const UserDetail = () => {
	const { id } = useParams();
	const navigate = useNavigate();

	const [loading, setLoading] = useState(true);
	const [btnDisabled, setBtnDisabled] = useState(false);
	const [showSpinner, setShowSpinner] = useState(false);

	const [username, setUsername] = useState("");
	const [mail, setMail] = useState("");
	const [password, setPassword] = useState("");
	const [tcNo, setTcNo] = useState("");
	const [birthday, setBirthday] = useState("");
	const [phoneNumber, setPhoneNumber] = useState("");
	const [company, setCompany] = useState("");
	const [devices, setDevices] = useState([]);
	const [organizations, setOrganizations] = useState([]);
	const [allDevices, setAllDevices] = useState([]);
	const [filteredDevices, setFilteredDevices] = useState([]);

	const getUser = async () => {
		try {
			const response = await fetch(`https://app.vivasmartcare.com/api/panel-users/${id}`);
			if (response.ok) {
				const userData = await response.json();
				setUsername(userData.username || "");
				setMail(userData.mail || "");
				setTcNo(userData.tcNo || "");
				setBirthday(userData.birthday || "");
				setPhoneNumber(userData.phoneNumber || "");
				setCompany(userData.company || "");
				setDevices(userData.devices || []);
			} else {
				alert("Kullanıcı bulunamadı");
				navigate("/user-list");
			}
		} catch (error) {
			console.error("Kullanıcı verileri getirilirken bir hata oluştu:", error);
			alert("Kullanıcı verileri yüklenirken bir hata oluştu");
		} finally {
			setLoading(false);
		}
	};

	const getOrganizations = async () => {
		try {
			const response = await fetch(`https://app.vivasmartcare.com/api/organisations`);
			const orgsData = await response.json();
			setOrganizations(orgsData);
		} catch (error) {
			console.error("Kurum verileri getirilirken bir hata oluştu:", error);
		}
	};

	const getDevices = async () => {
		try {
			const response = await fetch(`https://app.vivasmartcare.com/api/devices`);
			const devicesData = await response.json();
			setAllDevices(devicesData);
		} catch (error) {
			console.error("Cihaz verileri getirilirken bir hata oluştu:", error);
		}
	};

	useEffect(() => {
		if (id) {
			getUser();
			getOrganizations();
			getDevices();
		}
	}, [id]);

	// Kurum değiştiğinde o kuruma ait cihazları filtrele
	useEffect(() => {
		if (company && allDevices.length > 0) {
			const filtered = allDevices.filter(
				(device) => device.organization === company
			);
			setFilteredDevices(filtered);
		} else {
			setFilteredDevices([]);
		}
	}, [company, allDevices]);

	const handleUpdate = async (e) => {
		e.preventDefault();

		// Tekrarlanan cihazları kontrol et ve temizle
		const uniqueDevices = devices.filter((device, index, self) => {
			// Boş değerleri geç
			if (!device || device.trim() === "") return false;
			// İlk bulunan index'i kontrol et (tekrar edenleri filtrele)
			return self.indexOf(device) === index;
		});

		// Eğer tekrarlanan cihaz varsa uyarı ver
		if (uniqueDevices.length !== devices.filter((d) => d && d.trim() !== "").length) {
			alert("Tekrarlanan cihazlar kaldırıldı. Lütfen kontrol edin.");
			setDevices(uniqueDevices);
			return;
		}

		setBtnDisabled(true);
		setShowSpinner(true);

		try {
			const response = await fetch(`https://app.vivasmartcare.com/api/panel-users-update/${id}`, {
				method: "PUT",
				body: JSON.stringify({
					username,
					mail,
					password: password || undefined,
					tcNo,
					birthday,
					phoneNumber,
					company,
					devices: uniqueDevices,
				}),
				headers: { "Content-Type": "application/json" },
			});

			if (response.ok) {
				alert("Kullanıcı Güncellendi");
				navigate("/user-list");
			} else {
				alert("Kullanıcı güncellenirken bir hata oluştu");
			}
		} catch (error) {
			console.error("Güncelleme işlemi sırasında bir hata oluştu:", error);
			alert("Kullanıcı güncellenirken bir hata oluştu");
		} finally {
			setBtnDisabled(false);
			setShowSpinner(false);
		}
	};

	if (loading) {
		return (
			<Layout>
				<div
					className="user-modal-inputs"
					style={{ textAlign: "center", padding: "50px" }}
				>
					<Spinner animation="border" variant="primary" />
				</div>
			</Layout>
		);
	}

	return (
		<Layout>
			<div className="user-modal-inputs">
				<Form.Group style={{ display: "flex", justifyContent: "flex-end" }}>
					<a href="/view-contract">Sözleşme Görüntüle</a>
				</Form.Group>
				<Form onSubmit={handleUpdate}>
					<Form.Group>
						<label className="mb-2">Kullanıcı Adı:</label>
						<Form.Control
							type="text"
							placeholder="Kullanıcı Adı Giriniz:"
							value={username}
							required
							onChange={(e) => setUsername(e.target.value)}
						/>
					</Form.Group>
					<Form.Group>
						<label className="mb-2">Mail Adresi:</label>
						<Form.Control
							type="email"
							placeholder="Mail Adresi Giriniz:"
							value={mail}
							required
							onChange={(e) => setMail(e.target.value)}
						/>
					</Form.Group>
					<Form.Group>
						<label className="mb-2">Parola (Değiştirmek için yeni parola giriniz):</label>
						<Form.Control
							type="password"
							placeholder="Yeni Parola Giriniz (Boş bırakırsanız değişmez)"
							value={password}
							onChange={(e) => setPassword(e.target.value)}
						/>
					</Form.Group>
					<Form.Group>
						<label className="mb-2">TC No:</label>
						<Form.Control
							type="text"
							maxLength={11}
							minLength={11}
							value={tcNo}
							onChange={(e) => setTcNo(e.target.value)}
						/>
					</Form.Group>
					<Form.Group>
						<label htmlFor="birthday">Doğum Tarihi:</label>
						<Form.Control
							type="date"
							id="birthday"
							value={birthday}
							onChange={(e) => setBirthday(e.target.value)}
						/>
					</Form.Group>
					<Form.Group>
						<label className="mb-2">Telefon Numarası:</label>
						<InputMask
							mask="+90__________"
							replacement={{ _: /\d/ }}
							className="form-control"
							placeholder="Telefon No Giriniz:"
							showMask
							value={phoneNumber}
							onChange={(e) => setPhoneNumber(e.target.value)}
						/>
					</Form.Group>
					<Form.Group>
						<label className="mb-2">Kurum:</label>
						<Form.Select
							value={company}
							onChange={(e) => setCompany(e.target.value)}
						>
							<option value="">Kurum Seçiniz</option>
							{organizations?.map((org, index) => (
								<option value={org.organisationName} key={index}>
									{org.organisationName}
								</option>
							))}
						</Form.Select>
					</Form.Group>
					<Form.Group>
						<label className="mb-2">Cihazlar:</label>
						{devices.map((device, index) => {
							// Bu select için mevcut cihazı hariç tutarak, diğer tüm eklenmiş cihazları filtrele
							const availableDevices = filteredDevices.filter((dev) => {
								// Boş değerleri geç
								if (!dev.deviceID) return false;
								// Eğer bu select'te zaten bu cihaz seçiliyse göster (değiştirme için)
								if (device === dev.deviceID) return true;
								// Diğer select'lerde (bu index hariç) seçili olan cihazları gösterme
								const usedInOtherSelects = devices.some((d, i) => i !== index && d === dev.deviceID);
								return !usedInOtherSelects;
							});

							return (
								<div key={index} style={{ display: "flex", gap: "10px", marginBottom: "10px" }}>
									<Form.Select
										value={device}
										onChange={(e) => {
											const selectedDevice = e.target.value;
											// Eğer seçilen cihaz zaten başka bir yerde kullanılıyorsa uyarı ver
											if (selectedDevice && devices.includes(selectedDevice) && device !== selectedDevice) {
												alert("Bu cihaz zaten eklenmiş!");
												return;
											}
											const newDevices = [...devices];
											newDevices[index] = selectedDevice;
											setDevices(newDevices);
										}}
										style={{ flex: 1 }}
										disabled={!company}
									>
										<option value="">Cihaz Seçiniz</option>
										{availableDevices.map((dev) => (
											<option value={dev.deviceID} key={dev._id || dev.deviceID}>
												{dev.deviceID}
											</option>
										))}
									</Form.Select>
									{devices.length > 1 && (
										<Button
											variant="danger"
											size="sm"
											type="button"
											onClick={() => {
												const newDevices = devices.filter((_, i) => i !== index);
												setDevices(newDevices);
											}}
										>
											Sil
										</Button>
									)}
								</div>
							);
						})}
						<Button
							variant="outline-secondary"
							size="sm"
							type="button"
							onClick={() => {
								// Eğer tüm cihazlar zaten eklenmişse uyarı ver
								const allDevicesAdded = filteredDevices.every((dev) =>
									devices.includes(dev.deviceID)
								);
								if (filteredDevices.length > 0 && allDevicesAdded) {
									alert("Bu kuruma ait tüm cihazlar zaten eklenmiş!");
									return;
								}
								setDevices([...devices, ""]);
							}}
							style={{ marginTop: "10px" }}
							disabled={!company}
						>
							+ Cihaz Ekle
						</Button>
						{!company && (
							<small className="text-muted d-block mt-1">
								Lütfen önce bir kurum seçiniz
							</small>
						)}
					</Form.Group>
					<div className="button-wrapper">
						<Button
							variant="secondary"
							type="button"
							onClick={() => navigate("/user-list")}
						>
							İptal
						</Button>
						<Button variant="primary" type="submit" disabled={btnDisabled}>
							{showSpinner ? (
								<>
									<Spinner
										animation="border"
										size="sm"
										style={{ marginRight: "8px" }}
									/>
									Güncelleniyor...
								</>
							) : (
								"Güncelle"
							)}
						</Button>
					</div>
				</Form>
			</div>
		</Layout>
	);
};

export default UserDetail;
